import { SectionHeading } from './style'
import { EquipmentList } from './EquipmentList'

interface EquipmentSettingsProps {
    isEditable: boolean
}

export function EquipmentSettings({ isEditable }: EquipmentSettingsProps) {
    return (
        <>
            <SectionHeading>Оборудование</SectionHeading>
            <EquipmentList isEditable={isEditable} />
        </>
    )
}
